<template>
  <div>
    <!-- 그룹 탭 -->
    <!-- <childTab v-if="isTab()" :grpList="grpList" v-model="currentTab" @changeTab="changeTab" :depth="depth"/> -->
    <eng-main-content v-if="isContent" :subYn="true" :contents="[{contentNo: subContentNo, contentType: subContentType}]" :grpList="grpList" :depth="depth+1"/>
    <template v-if="!isContent && (dataItemList.length > 0 || headerList.length > 0)">
      <!-- 검색 영역 -->
      <div v-if="isSearchDiv()">
        <div class="search-bar">
          <select v-if="isTabList" v-model="searchParam.grpCd" title="Group classification" class="c-select">
            <template v-for="(item, index) in grpList">
              <option v-if="doSelect(item, index, 'grpCd')" selected :value="item.grpCd" :key="`sel_${index}`">{{item.grpNm}}</option>
              <option v-else :value="item.grpCd" :key="`nosel_${index}`">{{item.grpNm}}</option>
            </template>
          </select>
          <select v-if="isSearchList" v-model="searchParam.fieldCdNm" class="c-select" title="To search for">
            <template v-for="(item, index) in searchList">
              <option v-if="doSelect(item,index, 'fieldCd')" :selected="true" :value="item.fieldCdNm" :key="`sel_${index}`">{{item.fieldNm}}</option>
              <option v-else :value="item.fieldCdNm" :key="`nosel_${index}`">{{item.fieldNm}}</option>
            </template>
          </select>
          <input v-if="isSearchList" v-model="searchParam.keyword" type="text" class="c-input" placeholder="Search" @keydown="doSearchKeywordEnter" title="Search name">
          <button type="button" class="search-btn" title="Search button" @click="doSearch()"  @keydown="doSearchKeywordEnter"></button>
        </div>
      </div>
      <div v-if="!isSearchLoading">
        <!-- 게시물 영역 -->
        <div class="board-list__wrap">
          <p class="list-total">Total <b>{{pagingInfo.totalCnt}}</b> items (Page <strong>{{searchParam.currentPage}}</strong>/{{pagingInfo.totalPage}})</p>
          <ul class="board-list" v-if="dataItemList.length > 0">
            <li v-for="(item, index) in dataItemList" :key="index">
              <router-link :to="doLink(item)" :style="beforeStyle" :title="`${item.field03}_Move Page`">
                <img class="list-img" :src="item.imgUrl == null ? '' : encodeURI(item?.imgUrl)" @error="doImageError" :style="doImgStyle(item)"/>
                <div class="list-txt">
                  <template v-for="(subItem, subIdx) in headerList">
                    <template v-if="subItem.key == 'field03'">
                      <!-- 그룹 -->
                      <span v-if="(item.grpCd != null && item.grpCd != '') && board.ndisRequYn != 'Y' && board.grpYn == 'Y' && grpSize > 0" style="color: #979797;" :key="`grp_${subIdx}`">[{{item.grpNm}}]</span>
                      <!-- 제목 -->
                      <h3 v-if="item.field03 != null && item.field03 != ''" class="list-title" :key="`title_${subIdx}`">{{item.field03}}</h3>
                    </template>
                    <!-- 첨부파일 -->
                    <a v-else-if="subItem.key == 'field06'" @click="fileDownload(item.attcNo, item.attcSeqNo)" @keydown="doKeydownFileDown($event, item.attcNo, item.attcSeqNo)" class="btn_dw" :key="`a_${subIdx}`">
                      <span>{{$t('download')}}</span>
                    </a>
                    <!-- 등록일 -->
                    <p v-else-if="subItem.key == 'field17'" class="list-date" :key="`date${subIdx}`">{{dateEng(item.field17)}}</p>
                    <p v-else :key="`span_${subIdx}`">{{item[subItem.key]}}</p>
                  </template>  
                </div>
              </router-link>
            </li>
          </ul>
          <p v-else class="nodata pb180">No content is registered.</p>
        </div>
      </div>
      <div v-else>
        <overlay></overlay>
      </div> 
    </template>
    <div v-else>
      <overlay v-if="!isContent"></overlay>
    </div>
    <!-- 페이징 -->
    <pagination v-if="pagingInfo.totalPage > 0" :pagingInfo="pagingInfo" :currentPage="searchParam.currentPage" v-model="currentPageIdx"/>
    <!-- 파일 다운로드 -->
    <fileDownload ref="fileDown" v-show="false" :fileInfo="fileInfo"/>
  </div>
</template>

<script>
import fileDownload from '@/views_isoti/component/fileDownload';
import pagination from '@/views_isoti/component/Pagination';
import overlay from "@/views_isoti/component/Overlay";

import { downloadResponse } from '@/libs/comm/util';
import HDate from '@/libs/date';

export default {
  components: {
    pagination,
    fileDownload,
    overlay
  },
  props: {
    board: {
      type: Object,
      default: () => new Object()
    },
    grpList: {
      type: Array,
      default: () => []
    },
    depth: {
      type: Number
    },
  },
  computed:{
    grpSize() {
      return this.grpList.reduce((e,cur) => {
                  return cur.hiddenYn!="Y"?e+1:0
              },0)
    },
    beforeStyle(){
      return {
        '--img-before-height':this.board.imgHeight ?? '260px'
      } 
    }
  },
  watch: {
    currentPageIdx: {
      handler(newVal, oldVal) {
        const firData=(newVal??1) == 0?1:newVal??1;
        const seconData=(oldVal??1) == 0?1:oldVal??1;
      
        if(firData != seconData) {
          this.doPage(firData)
        }
      }
    },
    'board.boardNo'(newVal){
      if(this.searchParam.contentNo != newVal) {
        this.setSearchParam();
        this.subContentNo = null;

        if(this.board.grpDispCd == 'CMS009.select' && this.grpList != null && this.grpSize > 0) {
          this.isTabList = true;
        }

        if(this.grpList != null && this.grpSize > 0){
          if(this.isTabList || this.board.grpYn != 'Y' || this.board.ndisYn == 'Y' ) {
            const query = {...this.$route.query};

            this.searchParam.grpCd = query[`s${this.depth}`];
            this.doList();
          }else{
            this.setCurrentTab();
          }
        } else {
          this.doList();
        }
      }
    },
    '$route.query': {
      handler(newVal, oldVal){
        if(newVal != null && oldVal != null && JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.setSearchParam();
          this.currentPageIdx = newVal.page;
          
          if(this.grpList != null && this.grpSize > 0) {
            this.setCurrentTab();
          }

          // 컨텐츠유형 : 게시판 
          if(this.board.grpYn == 'N' && this.searchParam.grpCd == null || this.searchParam.grpCd == '') {
            if(newVal[`s${this.depth-1}`] == oldVal[`s${this.depth-1}`]) {
              // 탭 변경 이외 조회가능하게 
              this.doList()
            } 
          }else{
            // 컨텐츠유형 : 분류
            this.doList();
          }
        }
      }
    }
  },
  created() {
    this.hdate = new HDate();

    const grpYn = this.board?.grpYn;
    const grpDispCd = this.board?.grpDispCd;
    const ndisYn = this.board.ndisYn;
    const initPage = this.$route?.query?.page;

    if(initPage != null && initPage != ''){
      this.currentPageIdx = initPage
    }

    this.setSearchParam();
    this.title = this.subMenuTitle;

    //분류가 존재하는경우 분류를 통한 조회
    if(this.grpList != null && this.grpSize > 0 && grpDispCd != null && grpDispCd != '' && grpYn == 'Y') {
      if(ndisYn == 'Y' || grpDispCd == 'CMS009.select'){
        // 게시물 상세에서 뒤로가기 진행시 게시판 설정이 비공개이거나 선택상자 사용시 탭 세팅 안하고 바로 조회
        this.doList();
      }else{
        this.setCurrentTab()
      }
    }else{
      const boardNo = this.board?.boardNo;

      if(boardNo != null && boardNo != '') {
        // 글쓰기 및  상세 & 뒤로가기 할 때 조회 되게 
        this.doList();
      }
    }
  },
  data() {
    return {
      searchParam: {
        contentNo: '',
        currentPage: 1,
        fieldCdNm: null,
        pagePerNo: null,
        grpCd: null,
        keyword: '',
      },
      headerList: [],
      searchList: [],
      pagingInfo: {
        totalCnt: 0,
        firstPage: 0,
        lastPage: 0,
        nextPage: 0,
        prevPage: 0,
        totalPage: 0,
      },
      currentPageIdx: 1,
      dataItemList: [],
      currentTab: 'none',
      fileInfo: {
        fileComplet: null,
        fileSize: '5242880', 
        fileExt: ['hwp', 'doc', 'ppt', 'xls', 'txt', 'gif', 'jpg', 'docx', 'pptx', 'xlsx', 'zip', 'alz', 'rar', 'pdf'],
        fileCnt: 2,
        multiple: false,
        fileDownloadNm: this.$t('attcFile'),
      },
      isTabList: false,
      isSearchList: false,
      isContent: false,
      subContentNo: '',
      subContentType: 'A',
      isSearchLoading: false,
      hdate: null
    }
  },
  methods: {
    //기본파라미터 세팅
    setSearchParam() {
      const query = this.$route.query;
      const searchCD = query?.searchCD;
      const grpYn = this.board?.grpYn;
      const grpCd = query[`s${this.depth}`];
      const page = parseInt(query?.page);

      if(grpYn == 'Y' && this.grpSize > 0) {
        this.searchParam.grpCd = grpCd;
      }

      if(searchCD != null && searchCD != '') {
        this.searchParam.fieldCdNm = searchCD;
      }

      this.searchParam.pagePerNo = this.board?.pagePerNo;
      this.searchParam.currentPage = page > 0 ? page:1;
      this.searchParam.keyword = query?.keyword;
      this.searchParam.contentNo = this.board.boardNo;

      if(this.board.attcYn == 'Y') {
        this.fileInfo = {
          fileComplet: null,
          fileSize: this.board.attcLimitSize * 1048576, 
          fileExt: this.board.attcAllowExts,
          fileCnt: this.board.attcLimitNo,
          multiple: true,
          fileDownloadNm: this.$t('attcFile'),
        }
      }   
    },
    setMetaInfo() {
      const boardNm = this.board.boardNm;
      const url = document.location.href;
      const img = '/logo.png';
      const grpList = this.grpList;

      let metaInfoData = {
        title: '',
        ogTitle: boardNm,
        ogUrl: url,
        ogDescription: boardNm,
        ogImage: img,
      };
      
      metaInfoData.title = `${this.$t('정보보안연수원')}: ${boardNm}`;
      
      if(grpList != null && this.grpSize > 0) {
        const curTabData = grpList.find(e => e.grpCd == this.currentTab);

        if(curTabData != null) {
          const grpNm = curTabData.grpNm;
          if(grpNm != null && grpNm != '') {
            metaInfoData.title = `${this.$t('정보보안연수원')}: ${boardNm} > ${grpNm}`;
          }
        }
      }

      this.$store.dispatch('setMetaInfo', metaInfoData); 
    },
    isTab(){
      // 그룹 탭 리스트 
      const grpList = this.grpList;
      // 그룹 사용 컴포넌트 코드(탭 / 선택상자)
      const grpDispCd = this.board.grpDispCd;
      // 그룹사용여부
      const grpYn = this.board.grpYn;
      // 비공개 여부
      const ndisYn = this.board.ndisYn;
      // 비공개 필수 여부
      const ndisRequYn = this.board.ndisRequYn;

      if(grpList == null || this.grpSize < 1){
        return false;
      }

      if(grpYn != 'Y' || grpDispCd != 'CMS009.tab'){
        return false;
      }

      if(ndisYn == 'Y' && ndisRequYn == 'Y'){
        return false;
      }

      return true;
    },
    isSearchDiv() {
      const grpDispCd = this.board.grpDispCd;
      // 비공개 필수 여부
      const ndisRequYn = this.board.ndisRequYn;
      // 검색조건 선택 리스트
      const searchList = this.searchList;
      // 해당 게시판 그룹리스트(선택상자인 경우)
      const grpList = this.grpList;
      
      if(ndisRequYn == 'Y'){
        return false;
      }

      if(searchList == null || searchList.length < 1){
        this.isSearchList = false;
      }else{
        this.isSearchList = true;
      }

      if(grpDispCd == 'CMS009.tab' || grpList == null || this.grpSize < 1) {
        this.isTabList = false;
      }else{
        this.isTabList = true;
      }
      //검색조건이 없는경우 제외 하지만 그룹코드가 존재하는 경우 검색조건 활성화
      if(!this.isTabList && !this.isSearchList){
        return false;
      }
      
      return true;
    },
    changeTab(data, contentType, key, isSameAllow=false) {
      const query = {...this.$route.query};
      query[`s${this.depth}`] = key;
      let isSearch = true;
      //주소가 같이 않으면주소 변경
      if(JSON.stringify(this.$route.query) != JSON.stringify(query)){
        const param = {query};
        
        if(contentType != 'A') {
          this.searchParam.grpCd = data
        }else{
          this.searchParam.contentNo = data
        }

        delete param.query.page;
        this.searchParam.currentPage = 1;

        isSearch = false
        this.$router.push(param);
      }

      //컨텐츠가 분류가아니면 하위 컴포넌트 조회
      if(contentType != 'A'){
        //하위컨텐츠의 타입 전달
        this.subContentType = contentType
        this.isContent = true;
        this.subContentNo = data
      }else{
        this.isContent = false;
        this.subContentNo = '';
        //그룹코드를 통한 데이터 조회를 위한 설정
        if(this.searchParam.grpCd == null || this.searchParam.grpCd == '') {
          if(this.board.ndisRequYn == 'Y') {
            this.searchParam.grpCd = null
          }else{
            this.searchParam.grpCd = data
          }
        }

        if(isSearch){
          this.doList()
        }
      }
    },
    setCurrentTab() {
      const isFirst = this.$route.params.isFirst
      
      if(isFirst != null&& isFirst != ''){
        const grpList = this.grpList

        if(grpList != null && this.grpSize > 0){
          const firstGrpList = grpList[0]
          const grpCd = firstGrpList.grpCd
          const contentType = firstGrpList.contentType
          const linkUrl = firstGrpList.linkUrl
          
          if(this.currentTab == null){
            this.changeTab(contentType!='A'?linkUrl:grpCd, contentType, grpCd)
          }else{
            this.currentTab = grpCd
          }
        }
      }else{
        this.currentTab = this.$route.query[`s${this.depth}`]
      }
    },
    doSearchKeywordEnter(event) {
      if(event.keyCode == 13) {
        this.doSearch();
      }
    },
    doList() {
      this.isSearchLoading = true;
      this.$tran('/site/external/contents/selectPostImgList', this.searchParam).then(response => {
        this.dataItemList = response.data.postList
        this.searchList = response.data.searchList
        this.headerList = response.data.headerList
        this.pagingInfo = response.data.pagingInfo
        this.setMetaInfo();
      }).finally(() => {
        this.isSearchLoading=false
      })
    },
    doImageError(e) {
      e.target.src = require('@/assets/img/isoti/errorImage.png')
    },
    doPage(index) {
      const query = {...this.$route.query};

      this.searchParam.currentPage=index;
      this.currentPageIdx=index;
      query.page = index;

      if(JSON.stringify(this.$route.query) != JSON.stringify(query)){
        const param = {query};
    
        this.$router.push(param);
      }
    },
    doSelect(item, index, type) {
      if((this.searchParam.fieldCdNm == null || this.searchParam.fieldCdNm == '') && type == 'fieldCd') {
          if(index == 0){
            this.searchParam.fieldCdNm=item.fieldCdNm
          return true
        }
      }else if((this.searchParam.grpCd == null || this.searchParam.grpCd == '') && type == 'grpCd') {
        if(index == 0){
          this.searchParam.grpCd=item.grpCd
          return true
        }
      }else{
        return false
      }
    },
    doLink(item) {
      const query = {...this.$route.query}
      
      query['postNo'] = item.postNo

      if(this.board.grpYn == 'Y') {
        query[`s${this.depth}`] = this.searchParam.grpCd
      }

      return {name:'isoti_dynamicDetail', query: query}
    },
    doSearch() {
      const query = {...this.$route.query};
      // 검색 코드
      const searchCD = this.searchParam.fieldCdNm;
      // 검색어
      const keyword =  this.searchParam.keyword;
      // 그룹 
      const grpCd = this.searchParam.grpCd;
      // 그룹표시 코드
      const grpDispCd =  this.board.grpDispCd;

      if(grpDispCd == 'CMS009.select') {
        query[`s${this.depth}`] = grpCd;
      }
      
      if(keyword != null && keyword != '') {
        query.searchCD = searchCD;
        query.keyword = keyword;
      }else{
        delete query.searchCD;
        delete query.keyword;
      }

      delete query.page;
      this.searchParam.currentPage=1;

      if(JSON.stringify(this.$route.query) != JSON.stringify(query)){
        const param = {query};
        this.$router.push(param);
      }
    },
    doImgStyle(item) {
      const imgHeight = this.board.imgHeight; // 이미지높이
      const imgStyle = {
        height : imgHeight,
        objectFit : 'contain',
        'background-image': `url('${encodeURI(item?.imgUrl)}')`
      };

      return imgStyle;
    },
    fileDownload(attcNo, seqNo){
      const paramData = {
        attcNo: attcNo,
        seqNo: seqNo,
      };
      this.$tranFileDown('/site/file/downloadFile', paramData).then(response => {
        downloadResponse(response);
      }).catch(error => {
          this.response = error.message
      })
    },
    doKeydownFileDown(event, attcNo, seqNo) {
      if(event.keyCode == 13) {
        this.fileDownload(attcNo, seqNo);
      }
    },
    dateEng(date) {
      if(date != null && date != ''){
        return this.hdate.getMaskFormatString(this.hdate.strToDate(date.replaceAll('-','')),"dd, MMMM yyyy",'eng')
      }
      return ''
    }
  }
}
</script>